import React from 'react';
// components
import MNPGV2 from "@/components/MainPageLayouts/components/MNPGV2";
// hooks
import useMainPageItems from '@/hooks/useMainPageItems';
// types
import { THeaderComponent } from './type';
import { isEmpty } from 'lodash';


const Header = ( props:THeaderComponent ) => {
    const headerTemplates = useMainPageItems({mapLayoutName:"MNPGGRP_001"});

    if ( !headerTemplates || isEmpty(headerTemplates) ) return null;

    return (
        <header id="navbar" className="navbar-area dark-navbar">
            <MNPGV2 templates={headerTemplates} mapLayoutName={"MNPGGRP_001"} />
        </header>
    )
}

const Component = React.memo(Header, ( prevProps:THeaderComponent, nextProps:THeaderComponent ) => {
    console.log("Header.memo", { prevProps, nextProps });
    return true;
});

export default Component;
